module.exports = __webpack_public_path__ + "img/iconic21.5823ae81.png";